export default "__VITE_ASSET__fe052d34__"